import React from 'react';
import StandardButton from '../StandardButton/StandardButton';
import SweetAlert from 'react-bootstrap-sweetalert';
import { SweetAlertType } from 'react-bootstrap-sweetalert/dist/types';
import { t } from 'i18next';
import { capitalizeFirstLetter } from 'utils/helpers';
import StandardInput, {
  StandardInputPropsI
} from 'base/StandardInput/StandardInput';
import { UilInfoCircle } from '@iconscout/react-unicons';
import StandardCheckbox from 'base/StandardCheckbox/StandardCheckbox';
import { OptionI, ValidationObj } from '../../../types/interface';
import './DeleteModal.scss';

interface CheckboxI {
  showCheckbox: boolean;
  onChange: (value: boolean, data: OptionI) => void;
  data: OptionI[];
  checkedValues?: string[];
  className?: string;
  label: string;
  chechboxLabelClassname?: string;
  showError: boolean;
  errorMessage: string;
}

interface deleteModelI {
  warning?: boolean;
  title?: string;
  type?: SweetAlertType;
  showCancel?: boolean;
  showConfirm?: boolean;
  cancelText?: string;
  okText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
  showInput?: boolean;
  inputProps?: StandardInputPropsI;
  checkbox?: CheckboxI;
}

const DeleteModel = (props: deleteModelI) => {
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    <SweetAlert
      customClass="bg-body-emphasis"
      custom={true}
      customIcon={
        <div className="pb-3">
          <UilInfoCircle className="text-warning" height={70} width={70} />
        </div>
      }
      showCancel
      title={
        <span className="fs-6">
          {props.title || capitalizeFirstLetter(t('delete_model.delete'))}
        </span>
      }
      type={props.type}
      // input
      // inputType="textarea"
      placeholder="Write something longer..."
      customButtons={
        <React.Fragment>
          <div className="row justify-content-center w-70 ">
            {props.showCancel !== false ? (
              <div className="col-6 p-3">
                <StandardButton
                  className="w-100"
                  buttonText={
                    props.cancelText ||
                    capitalizeFirstLetter(t('delete_model.button.text_3'))
                  }
                  variant="outline-danger"
                  onClick={props.onCancel}
                  disabled={props.isLoading}
                />
              </div>
            ) : null}
            {props.showConfirm !== false ? (
              <div className="col-6 p-3">
                <StandardButton
                  className="w-100"
                  buttonText={
                    props.okText ||
                    capitalizeFirstLetter(t('delete_model.button.text_1'))
                  }
                  onClick={props.onConfirm}
                  disabled={props.isLoading}
                  isLoading={props.isLoading}
                />
              </div>
            ) : null}
          </div>
        </React.Fragment>
      }
      onConfirm={props.onConfirm}
      onCancel={props.onCancel}
      focusCancelBtn
    >
      {props?.checkbox?.data?.length && (
        <div className="row mt-2 delete-modal-checkbox">
          <h5 className="col-12 text-start mb-3">{props.checkbox?.label}</h5>
          <div className="col-12">
            {props.checkbox.data.map((c, i) => {
              return (
                <div className="col-12" key={i}>
                  <StandardCheckbox
                    className={props.checkbox?.className}
                    isChecked={
                      props.checkbox?.checkedValues?.includes(
                        c.value as string
                      ) || false
                    }
                    label={c.label}
                    setChecked={value => {
                      props.checkbox?.onChange(value, c);
                    }}
                    labelClassName={props?.checkbox?.chechboxLabelClassname}
                    showError={props?.checkbox?.showError}
                    formGroupClassName={'m-0'}
                  />
                </div>
              );
            })}
            <div className="text-danger fw-semibold fs-9 text-start mt-2">
              {props?.checkbox?.checkedValues?.length === 0 &&
              props?.checkbox?.showError
                ? props.checkbox?.errorMessage
                : ''}
            </div>
          </div>
        </div>
      )}
      {props.showInput && (
        <div className="row justify-content-center py-30">
          <div className="col-12">
            <StandardInput
              className={props.inputProps?.className || ''}
              label={props.inputProps?.label || ''}
              onChange={props.inputProps?.onChange || (() => {})}
              type={props.inputProps?.type || ''}
              value={props.inputProps?.value || ''}
              placeholder={props.inputProps?.placeholder || ''}
              showError={props.inputProps?.showError || false}
              validations={props.inputProps?.validations || []}
              {...props.inputProps}
            />
          </div>
        </div>
      )}
    </SweetAlert>
  );
};

export default DeleteModel;
